import React from "react";
import { useTranslation } from "react-i18next";

const ALLOWED_PDFS = {
  ar: "agenda-2-ar.pdf",
  en: "agenda-2-en.pdf",
};

const ConferanceAgenda = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language === "ar" ? "ar" : "en";
  const pdfFileName = ALLOWED_PDFS[lang];
  const pdfSrc = `/images/${pdfFileName}`;

  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(pdfSrc);
      if (!response.ok) throw new Error("Download failed");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = pdfFileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      // Fallback: open same-origin file
      window.open(pdfSrc, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <section>
      <p className="xl:text-4xl lg:text-4xl text-2xl font-semibold text-main 2xl:mt-16 lg:mt-12 mt-8 text-center">
        {lang === "ar" ? "أجندة المؤتمر" : "Conference Agenda"}
      </p>
      <div
        style={{ width: "100%", height: "90vh" }}
        className="container lg:mt-10 mt-6 mb-8 md:px-32 xl:px-44"
      >
        <iframe
          src={pdfSrc}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Viewer"
        />
      </div>
      <a
        href={pdfSrc}
        onClick={handleDownload}
        className="inline-block bg-main text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-opacity-90 transition duration-300 mb-14"
      >
        {lang === "ar" ? "تحميل الأجندة" : "Download Agenda"}
      </a>
    </section>
  );
};

export default ConferanceAgenda;
